import { loadStripe } from "@stripe/stripe-js";
import type { Appearance } from "@stripe/stripe-js";

// loadStripe is a promise — created once, outside render.
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY || ""
);

export const getStripe = () => stripePromise;

// Elements can't read CSS vars, so the palette is mirrored here per theme.
export const stripeAppearance = (theme: "light" | "dark"): Appearance => ({
  theme: theme === "dark" ? "night" : "stripe",
  variables: {
    colorPrimary: "#6366F1",
    colorBackground: theme === "dark" ? "#151A2D" : "#FFFFFF",
    colorText: theme === "dark" ? "#E8ECF7" : "#182546",
    colorDanger: "#F87171",
    fontFamily: "Raleway, sans-serif",
    borderRadius: "8px",
    spacingUnit: "4px",
  },
});
